var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-card',{staticClass:"md-card-profile"},[_c('div',{staticClass:"md-card-avatar"},[_c('img',{staticClass:"img",attrs:{"src":_vm.rutaApp +'storage/fotos/' + _vm.persona.fotoPerfil}})]),_c('md-card-content',[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.persona.persona))]),_c('p',{staticClass:"card-description"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }